import React from 'react';
import { createRoot } from 'react-dom/client';

import {
  getInitialLanguage,
  init as initFms,
} from '@storebrand-digital/fms-translations';
import { Version } from '@storebrand-digital/fms-translations/dist/types';
import auth from './utils/auth';

import intercept from './utils/intercept';
import { initProductHeaderFooter } from '@storeblocks/header-footer';
import App from './app';

import no from './fms-fallbacks/fallback-en.json';
import en from './fms-fallbacks/fallback-no.json';
import initDatadog from './utils/datadog';
import { getDatadogLogger } from '@storebrand-digital/common-datadog';
import {
  DATA_THEME_KEY,
  displayMode,
  getParamFromUrl,
  getThemeFromSessionStorage,
  isApp,
  isKronWebApp,
  KRON_DARK,
  KRON_LIGHT,
  storeDisplayModeInSessionStorage,
  storeThemeInSessionStorage,
} from './utils';
import { isKronWebView } from '@storebrand-digital/kron-web-view-helpers';
import './index.css';


function applyTheme() {
  if (isApp && displayMode) {
    storeDisplayModeInSessionStorage(displayMode);
  }

  if (isKronWebApp) {
    const theme = getParamFromUrl('theme') || getThemeFromSessionStorage();
    if (theme === KRON_DARK || theme === KRON_LIGHT) {
      document.documentElement.setAttribute(DATA_THEME_KEY, theme);
      storeThemeInSessionStorage(theme);
    }
  }
}

async function init() {
  applyTheme();

  await auth.init();
  if (!auth.authenticated) {
    await auth.login();
  }

  await intercept();

  if (process.env.NODE_ENV === 'production') {
    initDatadog();
  }

  await initFms({
    clientId: 'document-archive-web',
    documentIds: ['documentArchive'],
    fallback: {},
    language: getInitialLanguage(),
    version: window.env.TRANSLATION_VERSION as Version,
  });

  const isKron = isKronWebView || isKronWebApp || isApp;
  if (!isKron) {
    const isProduction = process.env.NODE_ENV === 'production';
    initProductHeaderFooter(isProduction ? 'production' : 'test');
  }

  const container = document.getElementById('root');

  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  } else {
    getDatadogLogger().error('Expected root container not found');
  }
}

init();
